// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1nYe6","content":"ManualTimeModal_content__19P0q"};